@if ((registrationStage$ | async) === RegistrationStage.NotSubmitted) {
  <glxy-alert
    (actionClick)="actionClicked()"
    [showAction]="true"
    [showClose]="true"
    (close)="closeClicked()"
    actionTitle=" {{ 'SMS_REGISTRATION.ALERT.UPDATE_INFO_ACTION_TITLE' | translate }}"
    class="alert-banner"
    [type]="alertType"
    >
    <span class="bold">{{ 'SMS_REGISTRATION.ALERT.BUSINESS_INFO_REQUIRED_TITLE' | translate }} -</span>
    {{ 'SMS_REGISTRATION.ALERT.MORE_DETAILS_SUGGESTION' | translate }}
  </glxy-alert>
}
@if ((registrationStage$ | async) === RegistrationStage.DataError) {
  <glxy-alert
    (actionClick)="actionClicked()"
    [showAction]="true"
    [showClose]="true"
    (close)="closeClicked()"
    actionTitle="{{ 'SMS_REGISTRATION.ALERT.UPDATE_INFO_ACTION_TITLE' | translate }}"
    class="alert-banner"
    type="error"
    >
    <span class="bold">{{ 'SMS_REGISTRATION.ALERT.REJECTED_TITLE' | translate }} -</span>
    {{ 'SMS_REGISTRATION.ALERT.REJECTED_SUGGESTION' | translate }}
  </glxy-alert>
}
